<template>
  <div>
    Address:
    <a v-bind:href="'https://bscscan.com/address/' + address" target="_blank"
      >{{ address.slice(0, 4) }}...{{ address.slice(-4) }}
      <i class="fad fa-external-link-alt m-r-xs"></i></a
    >BEP20
    <a v-bind:href="'https://etherscan.io/address/' + address" target="_blank"
      >{{ address.slice(0, 4) }}...{{ address.slice(-4) }}
      <i class="fad fa-external-link-alt m-r-xs"></i></a
    >ERC20
  </div>
</template>

<script>
export default {
  props: ["currency", "address"],
};
</script>
